import Vue from 'vue';
import BlogPanel from './App.vue';
import Buefy from 'buefy';

Vue.use(Buefy,{
    defaultIconPack: 'fas',
})

if(document.getElementById("blogPanelStaffApp")){
    new Vue({
        render: h=>h(
            BlogPanel, {
                props:{
                    sectionListCreate: document.getElementById("blogPanelStaffApp")
                        .getAttribute("section-list-create"),
                    sectionEdit: document.getElementById("blogPanelStaffApp")
                        .getAttribute("section-edit"),
                    entryListCreate: document.getElementById("blogPanelStaffApp")
                        .getAttribute("entry-list-create"),
                    entryEdit: document.getElementById("blogPanelStaffApp")
                        .getAttribute("entry-edit"),
                    addEntryForm: document.getElementById("blogPanelStaffApp")
                        .getAttribute("add-entry-form"),
                    basicInfoUrl: document.getElementById("blogPanelStaffApp")
                        .getAttribute("basic-info-url"),
                }
            }
        )
    }).$mount("#blogPanelStaffApp")
}
